module.exports = __webpack_public_path__ + "img/sanja_bijaksic.d09edb39.png";